<template>
  <div>
    <div class="submit-container" v-if="isCart && cartList.length > 0">
      <div class="cart-double-tip" v-if="hasLoadPaytype && isCartDoubleQuanTip">
        <span class="cart-double-tip-ico"></span>{{ letter.cartDoubleTip }}
      </div>
      <div
        class="cart-guide-tip j-click-use-cart-guide"
        v-if="showUseCartGuideTip"
        @click="handleUseCartGuide"
        :class="{ moreTop: hasLoadPaytype && isCartDoubleQuanTip }"
      >
        <span class="cart-guide-tip-ico"></span>{{ letter.cartGuideTipNew }}
        <div class="cart-guide-tip-btn"></div>
      </div>
      <div
        class="detail-container"
        :class="{ coupon: hasLoadPaytype && +paytype.coupon }"
        id="cartDetailContainer"
      >
        <div class="order-detail">
          <div class="order-detail-head">
            <div class="order-detail-head-title">
              {{ letter.has_select_product
              }}{{ letter.n_product.replace('${n}', cartTotalQuantity) }}
            </div>
            <span
              class="order-detail-head-cart j-click-open-cart"
              @click="lookCartList"
            >
              {{ letter.couponLookCart }}
            </span>
          </div>
          <div class="order-detail-content">
            <div class="order-detail-price">
              <p class="discount-price" v-if="paytype.coupon && hasLoadPaytype">
                <span>{{ letter.storeTotal }}：</span>
                <span class="price-wrap">
                  <span class="discount-total"
                    >{{ cartDiscountTransMount }} {{ currency }}</span
                  >
                  <span class="price-total" v-if="paytypeActiveCouponId"
                    >{{ cartTotalPrice }} {{ currency }}</span
                  >
                </span>
                <span v-if="isShowTax">
                  {{ `+ ${curTax} ${currency}(tax)` }}
                </span>
              </p>
              <p class="price" v-else>
                {{ letter.storeTotal }}：
                <span class="price-total"
                  >{{ cartTotalPrice }} {{ currency }}</span
                >
                <span v-if="isShowTax">
                  {{ `+ ${curTax} ${currency}(tax)` }}
                </span>
              </p>
              <p class="paytype-tip" v-if="!hasLoadPaytype">
                {{ letter.couponSelectPaytypeTip }}
              </p>
              <span class="extra" v-if="cartTotalExtraCoin > 0"
                >{{ letter.storeExtra }}：{{ cartTotalExtraCoin
                }}<span style="margin: 0 5px">{{ extraCoinName }}</span></span
              >
            </div>
            <div
              class="order-detail-right"
              :class="{ flexEnd: !hasLoadPaytype || !paytype.coupon }"
            >
              <div
                class="order-coupon j-select-coupon-entry"
                v-if="paytype.coupon && hasLoadPaytype"
              >
                <div
                  class="order-coupon-choose"
                  :class="{ highlight: !paytypeActiveCouponId }"
                  @click="showPaytypeCouponPopup"
                >
                  <template v-if="!paytypeActiveCouponId">
                    <p class="order-coupon-choose-text highligh">
                      {{ letter.couponHasNoSelect }}
                    </p>
                    <p class="order-coupon-choose-text highligh">
                      {{
                        letter.couponValidQuanTip.replace(
                          '${num}',
                          paytypeEnableCouponList.length
                        )
                      }}
                    </p>
                  </template>
                  <p
                    class="order-coupon-choose-text"
                    v-else-if="activePaytypeCouponFullReductType"
                  >
                    {{ letter.couponHasSelectQuan }}：{{
                      activePaytypeCouponReductionName
                    }}
                  </p>
                  <p class="order-coupon-choose-text" v-else>
                    {{ letter.couponHasSelectQuan }}：{{
                      activePaytypeCouponDiscountName
                    }}
                  </p>
                </div>
                <p class="order-coupon-tip" v-if="paytypeActiveCouponId">
                  {{ letter.couponSubmitTip }}
                </p>
              </div>
              <Button
                class="submit-btn j-click-confirm-cart"
                pointClass="j-click-confirm-cart"
                v-if="!showCartList && !hasLoadPaytype"
                @click="lookCartList"
              >
                {{ letter.confirm_product }}
              </Button>
              <Button
                class="submit-btn j-click-select-pay-way-cart"
                pointClass="j-click-select-pay-way-cart"
                v-if="showCartList && !hasLoadPaytype"
                @click="loadCartPaytypeListData"
              >
                {{ letter.select_paytype }}
              </Button>
              <Button
                class="submit-btn"
                pointClass=""
                v-if="hasLoadPaytype"
                @click="postOrder"
                :loading="submitLoading"
              >
                {{ submitOrderBtnText }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cart-list
      v-if="showCartList"
      v-on:closeSelecter="setShowCartList(false)"
      v-bind:showChildSelector="showCartList"
    ></cart-list>
    <cart-delete-popup
      v-if="showCartDeletePopup"
      v-on:closeSelecter="hideCartDeletePopup"
      v-bind:showChildSelector="showCartDeletePopup"
    ></cart-delete-popup>
  </div>
</template>

<script>
import CartList from '@components/officialStore/cart/CartList.vue';
import CartDeletePopup from '@components/officialStore/cart/CartDeletePopup.vue';
import {
  UPDATE_LOADING,
  UPDATE_HAS_SELECT_PRODUCT,
  SET_SHOW_CHANNEL_STATUS,
  SET_HAS_LOAD_PAYTYPE
} from '@store/officialStore';
import {
  LOAD_CART_PAYTYPE_LIST_DATA,
  UPDATE_SHOW_CARTLIST_STATUS,
  UPDATE_SHOW_CART_DELETE_POPUP,
  UPDATE_IS_CART
} from '@store/officialStore/cart';
import {
  storeProductParam,
  getCurLocation
} from '@store/officialStore/storager';
import globalConfig from '@utiles/officialStore/globalConfig';
import coupon from '@mixins/officialStore/coupon';
import zipcode from '@mixins/officialStore/zipcode';
import { mapState, mapGetters } from 'vuex';
import { times, b64EncodeUnicode } from '@utiles/officialStore';
import pay from '@mixins/officialStore/pay';

export default {
  name: 'cartSubmitFooter',
  mixins: [coupon, pay, zipcode],
  props: ['submitLoading'],
  data() {
    return {
      showDetailPopup: false,
      lookDetailItem: {},
      currency: ''
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      hasLoadPaytype: state => state.hasLoadPaytype,
      coin_name: state => state.coin_name,
      paytype: state => state.paytype,
      gameId: state => state.gameId,
      serverId: state => state.pcServerId,
      roleId: state => state.roleId,
      roleName: state => state.roleName,
      lang: state => state.lang,
      showCartDeletePopup: state => state.cart.showCartDeletePopup,
      showCartList: state => state.cart.showCartList,
      cartList: state => state.cart.cartList,
      isCart: state => state.cart.isCart,
      isUidLogin: state => state.login.isUidLogin,
      uid: state => state.login.uid,
      zipCode: state => state.zipCode,
      curLocation: state => state.curLocation,
      curTax: state => state.curTax
    }),
    ...mapGetters([
      'cartTotalPrice',
      'cartTotalExtraCoin',
      'cartTotalQuantity',
      'cartDiscountTransMount',
      'cartProductType',
      'gameInfoConfig',
      'getPointPayChannelName',
      'extraCoinName'
    ]),
    reductionName() {
      return (
        '-' +
        this.activeCouponInfo.REDUCTION_MONEY +
        this?.paytype?.show_currency
      );
    },
    discountName() {
      return times(this.activeCouponInfo.DISCOUNT, 100) + '%OFF';
    },
    isCartDoubleQuanTip() {
      return this.gameInfoConfig.isCartDoubleQuanTip;
    },
    submitOrderBtnText() {
      if (
        this?.paytype &&
        this?.paytype?.f_pay_type === this.getPointPayChannelName &&
        this.isUidLogin
      ) {
        return this.letter.uidLoginName;
      } else {
        return this.letter.submitOrder;
      }
    },
    isShowTax() {
      return (
        +this.curTax > 0 &&
        this.curLocation === 'US' &&
        this.paytype?.pay_type !== 'user_balance_pay'
      );
    },
    getRefreshTax() {
      const { cartTotalPrice, cartDiscountTransMount, zipCode } = this;
      return {
        cartTotalPrice,
        cartDiscountTransMount,
        zipCode
      };
    }
  },
  watch: {
    paytype: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal?.show_currency) {
          this.currency = newVal?.show_currency;
        }
      }
    },
    cartList: {
      deep: true,
      handler(newVal) {
        if (newVal.length === 0) {
          this.setShowCartList(false);
          this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
          this.$store.commit(UPDATE_IS_CART, false);
          this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
          this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
        }
      }
    },
    getRefreshTax: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (
          this.curLocation === 'US' &&
          newVal.zipCode &&
          newVal.cartTotalPrice
        ) {
          this.getCurrentTax({
            zipCode: newVal.zipCode,
            amount: this.paytype.coupon
              ? this.cartDiscountTransMount
              : this.cartTotalPrice,
            currency: this.currency
          });
        }
      }
    }
  },
  methods: {
    getCartListParam() {
      return this.cartList.map(item => {
        return {
          productId: item.PRODUCT_ID,
          cpProductId: item.CP_PRODUCT_ID,
          remark: item.REMARK || '',
          amount: item.amountLevel.TRANS_AMOUNT || '',
          quantity: item.quantity,
          productDesc: item?.CP_PRODUCT_DESC || item?.PRODUCT_DESC || '',
          cpProductExt: item.CP_PRODUCT_EXT || {}
        };
      });
    },
    hideCartDeletePopup() {
      this.$store.commit(UPDATE_SHOW_CART_DELETE_POPUP, false);
    },
    setShowCartList(status) {
      this.$store.commit(UPDATE_SHOW_CARTLIST_STATUS, status);
    },
    postOrder() {
      this.$emit('postOrder');
    },
    lookCartList() {
      this.setShowCartList(true);
      this.sendCheckCartData();
    },
    sendCheckCartData() {
      window.webstorev1DataLayer.push({
        eventName: 'check_cart',
        eventType: 'add_to_cart',
        eventReason: 'click_select',
        eventValue: {
          product_type: this.cartProductType,
          cp_product_id: '',
          product_id: '',
          product_num: this.cartList.length,
          product_list: b64EncodeUnicode(
            JSON.stringify(this.getCartListParam())
          ),
          product_currency: this.currency,
          product_money: this.cartTotalPrice
        }
      });
    },
    loadCartPaytypeListData() {
      this.sendCheckCartData();
      storeProductParam({
        gameId: this.gameId,
        serverId: this.serverId,
        roleId: this.roleId,
        roleName: this.roleName,
        packageName: globalConfig.getHrefParam('packageName'),
        userId: this.uid,
        devicePlate: globalConfig.getHrefParam('devicePlate'),
        location: getCurLocation() || '',
        appLanguage: this.lang,
        language: this.lang,
        productType: this.cartProductType
      });
      this.$store.commit(UPDATE_LOADING, true);
      this.$store.dispatch(LOAD_CART_PAYTYPE_LIST_DATA);
      this.setShowCartList(false);
    }
  },
  components: {
    CartList,
    CartDeletePopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.submit-container {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 21;
  box-sizing: border-box;
  padding: 0 36px;
  width: 100%;
  background: var(--submit-bg);
  font-size: 0;
}
.cart-double-tip {
  position: absolute;
  display: flex;
  align-items: center;
  left: 0;
  top: -38px;
  width: 100%;
  height: 38px;
  border-top: 1px solid var(--submit-cart-double-tip-border);
  border-bottom: 1px solid var(--submit-cart-double-tip-border);
  font-size: 20px;
  background: var(--submit-cart-double-tip-bg);
  color: var(--submit-cart-double-tip);
  box-sizing: border-box;
  font-weight: bold;
  &-ico {
    position: relative;
    margin: 0 5px 0 36px;
    @psetbg ('cart-double-tip-ico.png');
  }
}
.cart-guide-tip {
  position: absolute;
  display: flex;
  align-items: center;
  left: 0;
  top: -50px;
  width: 100%;
  height: 50px;
  font-size: 22px;
  background-color: #e5d9cc;
  border: solid 2px #bca892;
  color: #906d1d;
  box-sizing: border-box;
  font-weight: bold;
  cursor: pointer;
  &.moreTop {
    top: -88px;
  }
  &-ico {
    position: relative;
    margin: 0 5px 0 16px;
    @psetbg ('cart-guide-ico.png');
  }
  &-btn {
    position: absolute;
    right: 27px;
    top: 50%;
    transform: translateY(-50%);
    @psetbg ('cart-guide-btn.png');
  }
}
.detail-container {
  display: block;
  float: left;
  position: relative;
  box-sizing: border-box;
  padding: 22px 0;
  width: 100%;
  height: auto !important;
  min-height: 180px;
  max-height: 240px;
  &.coupon {
    height: 236px;
  }
}
.order-detail {
  &-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    &-title {
      color: var(--submit-title);
    }
    &-cart {
      color: var(--submit-cart);
    }
  }
  &-content {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    .order-detail-price {
      font-size: 30px;
      color: var(--submit-discount);
      .discount-price {
        display: flex;
        font-weight: bold;
        align-items: end;
        .price-wrap {
          display: flex;
          flex-direction: column;
        }
        .discount-total {
          font-size: 41px;
        }
        .price-total {
          text-decoration: line-through;
          text-decoration-color: var(--submit-price-hua);
          font-size: 24px;
          color: var(--submit-price);
        }
      }
      .price {
        font-weight: bold;
        .price-total {
          font-size: 41px;
        }
      }
      .paytype-tip {
        margin-top: 10px;
        font-size: 20px;
        color: var(--submit-tip);
      }
      .extra {
        display: inline-block;
        margin-top: 10px;
        padding: 5px 10px;
        border: 1px solid var(--submit-extra-border);
        text-align: center;
        font-size: 20px;
        color: var(--submit-extra);
      }
    }
    .order-detail-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &.flexEnd {
        justify-content: flex-end;
      }
      .order-coupon {
        &-choose {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-bottom: 15px;
          padding: 5px 10px;
          border: 1px solid var(--submit-coupon-choose-border);
          font-size: 24px;
          color: var(--submit-coupon-choose);
          &-text {
            line-height: 30px;
          }
        }
        &-tip {
          margin-bottom: 15px;
          font-size: 20px;
          color: var(--submit-tip);
        }
        .highligh {
          color: var(--submit-coupon-unchoose);
        }
      }
      .submit-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: cover;
        cursor: pointer;
        font-size: 24px;
        color: var(--submit-btn);
        @psetbg ('submit.png');
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .submit-container {
    left: 50%;
    width: 1202px;
    transform: translateX(-50%);
  }
  .order-detail-content .order-detail-right .submit-btn {
    display: flex;
    @psetbg ('submit-hen.png');
  }
}
</style>
